import FlatList from "../../../../../common/FlatTable/FlatList";
import { MENU_ITEMS } from "./constants/constants";

import "./flatStyles.scss";

const MAX_IOC_ROWS = 60;

// Stateless counterpart of Iocs.js: that widget is a sidebar master/detail pane
// whose list is height clamped, so only one category would ever be captured.
const IocsFlat = ({ iocs }) => (
  <div className="android-iocs-flat">
    {MENU_ITEMS.map((menuItem) => (
      <FlatList
        key={menuItem.id}
        title={menuItem.header}
        items={iocs?.[menuItem.id]}
        maxRows={MAX_IOC_ROWS}
        moreLabel="indicators"
      />
    ))}
  </div>
);

export default IocsFlat;
